export const subscribeTokenToTopic = (token, topic) => {
  // Retrieve the server key from environment variables
  const apiKey = 'AAAAju6BvbY:APA91bFJKA24QZn5xxxiV2LiEfA2NZKIMvDQZgmE3D6MnK7btFUQVTjV06ArO-5ZgwqIT-Dq-xppIw6uCgvlIyk5R5aOGC1DMJE8fmbZ6E4JGq8XQvGaBAel-d5-oLe6g1ae7LxlROwI';

  return fetch(`https://iid.googleapis.com/iid/v1/${token}/rel/topics/${topic}`, {
    method: 'POST',
    headers: {
      'Authorization': `key=${apiKey}`,
      'Content-Type': 'application/json',
    },
  })
    .then((response) => {
      if (response.ok) {
        // If the subscription is successful, log a success message
        console.log(`${topic} is subscribed`);
        return true;
      } else {
        // If the subscription fails, log an error message
        console.error(`Failed to subscribe to ${topic}:`, response.statusText);
        return false;
      }
    })
    .catch((error) => {
      // Log an error if an exception occurs during the fetch operation
      console.error('Error:', error);
      return false;
    });
};

export default subscribeTokenToTopic;
